import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type React from 'react'
import {
  INVESTMENT_PACKAGE_LABELS,
  INVESTMENT_PACKAGE_OPTIONS,
} from '../constants/investmentPackages'
import type { InvestmentPackage } from '../types/coreApi-types'
import DropdownCell from './DropdownCell'
import DropdownMenu from './DropdownMenu'

interface InvestmentPackageSelectorProps {
  label: string
  value: InvestmentPackage | null
  onChange: (value: InvestmentPackage) => void
  className?: string
  options?: InvestmentPackage[]
}

const InvestmentPackageSelector: React.FC<InvestmentPackageSelectorProps> = ({
  label,
  value,
  onChange,
  className = '',
  options,
}) => {
  const availableOptions = options
    ? INVESTMENT_PACKAGE_OPTIONS.filter(option => options.includes(option.id))
    : INVESTMENT_PACKAGE_OPTIONS

  return (
    <div className={className}>
      <p className="text-description-subtle mb-2">{label}</p>
      <DropdownMenu
        renderList={availableOptions.map(option => (
          <DropdownCell
            key={option.id}
            title={option.title}
            subtitle={option.dropdownSummary}
            onClick={() => onChange(option.id)}
            isActive={value === option.id}
          />
        ))}
      >
        <div className="input text-start flex items-center pl-3">
          {value ? (
            <div className="flex-1">
              <p className="text-sm font-medium">
                {INVESTMENT_PACKAGE_LABELS[value]}
              </p>
            </div>
          ) : (
            <p className="text-description">Select an investment package</p>
          )}
          <div className="absolute right-0 top-0 bottom-0 flex items-center mr-3 text-brand-light-text-description">
            <FontAwesomeIcon icon={faCaretDown} size="sm" />
          </div>
        </div>
      </DropdownMenu>
    </div>
  )
}

export default InvestmentPackageSelector
